import React, { useState } from 'react';

const initialData = { loan_amt: '', loan_percent: '', loan_cycle_installment_amt: '', loan_no_of_emi: '' };
const money = (value) => Number(value || 0).toFixed(2);

export default function LoanProductPreview() {
  const [form, setForm] = useState(initialData);
  const [schedule, setSchedule] = useState([]);
  const [error, setError] = useState('');

  const preview = (event) => {
    event.preventDefault();
    const amount = Number(form.loan_amt);
    const rate = Number(form.loan_percent);
    const installment = Number(form.loan_cycle_installment_amt);
    const emiCount = Number(form.loan_no_of_emi);
    if (![amount, rate, installment, emiCount].every((value) => Number.isFinite(value) && value > 0)) {
      setError('Enter valid positive loan terms to generate the preview.');
      setSchedule([]);
      return;
    }

    let remaining = amount;
    const rows = [];
    for (let installmentNo = 1; installmentNo <= emiCount; installmentNo += 1) {
      const openingBalance = remaining;
      const interest = (openingBalance * rate) / 5200;
      const principal = Math.max(0, installment - interest);
      remaining = Math.max(0, openingBalance - principal);
      rows.push({ installmentNo, openingBalance, principal, interest, installment, closingBalance: remaining });
    }
    setError(remaining > 0.01 ? `The selected installment leaves Rs ${money(remaining)} outstanding after ${emiCount} EMIs.` : '');
    setSchedule(rows);
  };

  const totals = schedule.reduce((total, row) => ({ principal: total.principal + row.principal, interest: total.interest + row.interest, installment: total.installment + row.installment }), { principal: 0, interest: 0, installment: 0 });

  return <div className="container py-4">
    <h2>EMI Preview</h2>
    <p className="text-muted">Preview the weekly repayment schedule before creating a loan product.</p>
    <form className="row g-3 mb-4" onSubmit={preview}>
      <div className="col-md-3"><label>Loan Amount</label><input type="number" min="1" className="form-control" value={form.loan_amt} onChange={(event) => setForm({ ...form, loan_amt: event.target.value })} required /></div>
      <div className="col-md-3"><label>Interest %</label><input type="number" min="0.01" step="0.01" className="form-control" value={form.loan_percent} onChange={(event) => setForm({ ...form, loan_percent: event.target.value })} required /></div>
      <div className="col-md-3"><label>Weekly Installment</label><input type="number" min="1" className="form-control" value={form.loan_cycle_installment_amt} onChange={(event) => setForm({ ...form, loan_cycle_installment_amt: event.target.value })} required /></div>
      <div className="col-md-3"><label>Number of EMIs</label><input type="number" min="1" className="form-control" value={form.loan_no_of_emi} onChange={(event) => setForm({ ...form, loan_no_of_emi: event.target.value })} required /></div>
      <div className="col-12"><button className="btn btn-primary">Generate Preview</button></div>
    </form>
    {error ? <div className="alert alert-warning">{error}</div> : null}
    <div className="table-responsive data-table-shell"><table className="table table-bordered data-table"><thead><tr><th>EMI No.</th><th>Opening Principal</th><th>Principal</th><th>Interest</th><th>Installment</th><th>Closing Principal</th></tr></thead><tbody>{schedule.length ? schedule.map((row) => <tr key={row.installmentNo}><td>{row.installmentNo}</td><td>{money(row.openingBalance)}</td><td>{money(row.principal)}</td><td>{money(row.interest)}</td><td>{money(row.installment)}</td><td>{money(row.closingBalance)}</td></tr>) : <tr><td colSpan="6" className="text-center">Enter loan terms and generate a preview.</td></tr>}</tbody>{schedule.length ? <tfoot><tr><th>Total</th><th>-</th><th>{money(totals.principal)}</th><th>{money(totals.interest)}</th><th>{money(totals.installment)}</th><th>{money(schedule[schedule.length - 1].closingBalance)}</th></tr></tfoot> : null}</table></div>
  </div>;
}
